//* MUI imports
import { Box, SxProps } from '@mui/material';

import React from 'react';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import HeaderIcon, { HeaderIconProps } from '../HeaderIcon';

import { FeatureIconV2 } from '@geneo2-web/shared-ui';
//* Interface
interface HeaderIconWrapperProps {
  icons: HeaderIconProps[];
  featureIconStyles?: SxProps;
}

const styles: IStyles = {
  root: {
    boxSizing: 'border-box',
    width: '100%',
    display: { xs: 'inline-table', md: 'flex' },
    backgroundColor: '#fff',
    boxShadow: { xs: 'none', md: '-1px 3px 8px -2px rgba(0,0,0,0.30)' },
    justifyContent: 'center',

    p: {
      xs: `${pxToRem(17)} ${pxToRem(10)}`,
      md: pxTovW(14),
    },
    overflow: 'scroll',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  container: {
    width: { xs: '100%' },

    display: 'flex',

    justifyContent: {
      xs: 'space-between',
      md: 'center',
    },

    '&>div': {
      width: 'max-content',
    },
    border: 'none',
  },
};

export const HeaderIconWrapperV2: React.FC<HeaderIconWrapperProps> = (
  props
) => {
  const { icons, featureIconStyles } = props;
  if (!icons.length) {
    return null;
  }
  return (
    <Box sx={styles.root}>
      <Box
        sx={{
          ...styles,
          display: 'flex', // { xs: 'list-item', lg: 'flex' },

          gap: { xs: pxTovW(20), lg: pxTovW(50) },
          flexWrap: 'wrap',
          padding: { xs: pxTovW(0), lg: pxTovW(20) },
        }}
      >
        {icons.map((icon, index) =>
          icon.isHidden ? null : (
            <FeatureIconV2
              key={`HeaderIcon-${index}`}
              fileName={icon.fileName}
              imageType={icon.type || 'png'}
              cardText={icon.cardText ?? ''}
              parentFolder="icons"
              onClick={icon.onClick} // ✅ Fixed here
              isDisabled={icon.isDisabled}
              rootStyles={featureIconStyles}
            />
          )
        )}
      </Box>
    </Box>
  );
};

export default HeaderIconWrapperV2;
